import { ConsumerCardMessaging as ConsumerCardMessagingComponent }
from './component/ConsumerCardMessaging/ConsumerCardMessaging.component';
import { PLCCPod } from './component/PLCCPod/PLCCPod.component';
import { SaveCardModal } from './component/SaveCardMessaging/SaveCardModal.component';
import NonCardholderView from './component/NonCardholderView/NonCardholderView.component';
import AccountSelectorModal from './component/common/account-selector-modal-stencil/account-selector-modal-stencil';
import AccountSelectorDrawer from './component/common/account-selector-drawer.component';
import { CardholderView } from './component/CardholderView/CardholderView.component';
import { DynamicDiscount } from './component/DynamicDiscount/DynamicDiscount.component';
import TermsAndConditionsDrawer from './component/common/terms-and-conditions-drawer.component';
import { TermsAndConditionsDrawerContentful as TermsAndConditionsDrawerContentfulComponent }
from './component/common/terms-and-conditions-drawer-contentful.component';
import ProXtraDrawer from './component/common/pro-xtra-drawer.component';
import { ApplyNowModal } from './component/common/apply-now-modal/apply-now-modal.component';
import { PLCCBanner } from './component/PLCCBanner/PLCCBanner.component';
import { PLCCCheckoutPrompt } from './component/PLCCCheckoutPrompt/PLCCCheckoutPrompt.component';

import { PLCCB2BRightRailMessage } from './component/PLCCRightRailMessage/PLCCB2BRightRailMessage.component';
import { PLCCB2CRightRailMessage } from './component/PLCCRightRailMessage/PLCCB2CRightRailMessage.component';
import { PLCCPromptPaymentEstimator }
from './component/PLCCPromptPaymentEstimator/PLCCPromptPaymentEstimator.component';
import { PLCCPreQualified } from './component/PLCCPreQualified/PLCCPreQualified.component';
import { NoImpact } from './component/NoImpact/NoImpact.component';
import { IntroOffer } from './component/ConsumerCardMessaging/intro-offer/intro-offer.component';
import { PaymentEstimator }
from './component/ConsumerCardMessaging/payment-estimator/legacy-payment-estimator.component';
import { withContentfulWrapper } from './providers/WithContentfulWrapper';

export const ConsumerCardMessaging = withContentfulWrapper(ConsumerCardMessagingComponent);
export const TermsAndConditionsDrawerContentful = withContentfulWrapper(TermsAndConditionsDrawerContentfulComponent);

export {
  PLCCPod,
  SaveCardModal,
  NonCardholderView,
  AccountSelectorModal,
  AccountSelectorDrawer,
  CardholderView,
  DynamicDiscount,
  TermsAndConditionsDrawer,
  ProXtraDrawer,
  ApplyNowModal,
  PLCCBanner,
  PLCCCheckoutPrompt,
  PLCCB2BRightRailMessage,
  PLCCB2CRightRailMessage,
  PLCCPreQualified,
  NoImpact,
  IntroOffer,
  PaymentEstimator,
  PLCCPromptPaymentEstimator,
};